(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[492],{

/***/ 9937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(4238);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ BlogArticle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1221);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4768);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_ArticleRecommendation_ArticleRecommendation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5996);
/* harmony import */ var _components_DiscoverBeneBono_DiscoverBeneBono__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9451);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3376);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_ShareButton_ShareButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(576);
/* harmony import */ var _components_Nav_Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4193);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8287);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7294);
/* harmony import */ var _components_RefreshedFooter_RefreshedFooter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1216);
/* provided dependency */ var process = __webpack_require__(3454);















var __N_SSG = true;
function BlogArticle(param) {
    let { post , latestsPosts , navigation , footer  } = param;
    var _post_seo, _post_seo1, _post_seo2, _post_seo_metaImage, _post_seo_metaImage_data, _post_seo_metaImage_data_attributes;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$G)();
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        var _window_rudderanalytics;
        window === null || window === void 0 ? void 0 : (_window_rudderanalytics = window.rudderanalytics) === null || _window_rudderanalytics === void 0 ? void 0 : _window_rudderanalytics.page();
    }, []);
    const tags = post.tags.data.map((t)=>t.attributes.name);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: post === null || post === void 0 ? void 0 : post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: post === null || post === void 0 ? void 0 : (_post_seo = post.seo) === null || _post_seo === void 0 ? void 0 : _post_seo.metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Bene Bono"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: post === null || post === void 0 ? void 0 : (_post_seo1 = post.seo) === null || _post_seo1 === void 0 ? void 0 : _post_seo1.metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: post === null || post === void 0 ? void 0 : (_post_seo2 = post.seo) === null || _post_seo2 === void 0 ? void 0 : (_post_seo_metaImage = _post_seo2.metaImage) === null || _post_seo_metaImage === void 0 ? void 0 : (_post_seo_metaImage_data = _post_seo_metaImage.data) === null || _post_seo_metaImage_data === void 0 ? void 0 : (_post_seo_metaImage_data_attributes = _post_seo_metaImage_data.attributes) === null || _post_seo_metaImage_data_attributes === void 0 ? void 0 : _post_seo_metaImage_data_attributes.url
                    }),
                    process.env.PLASMIC_ENV !== "production" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Nav_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                links: navigation.links
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "single_article_container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "article_header",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        onClick: ()=>router.push("/blog"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_5__/* .ArrowLeft */ .Xd, {}),
                                            " ",
                                            t("blog.back.button")
                                        ]
                                    }),
                                    tags.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        children: tags.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: t
                                            }, i))
                                    }) : "",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: post === null || post === void 0 ? void 0 : post.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "article_header_info",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: post === null || post === void 0 ? void 0 : post.author
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: dayjs__WEBPACK_IMPORTED_MODULE_2___default()(post === null || post === void 0 ? void 0 : post.publishedAt).format("DD MMMM YYYY")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "content",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "article_content",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_13__/* .ReactMarkdown */ .D, {
                                            disallowedTypes: [
                                                "Paragraph"
                                            ],
                                            rehypePlugins: [
                                                rehype_raw__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z
                                            ],
                                            children: post === null || post === void 0 ? void 0 : post.content
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DiscoverBeneBono_DiscoverBeneBono__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ArticleRecommendation_ArticleRecommendation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: t("last.article.title"),
                        link: "blog",
                        data: latestsPosts,
                        imageUrl: "https://images.unsplash.com/photo-1610348725531-843dff563e2c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RefreshedFooter_RefreshedFooter__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                links: footer.links
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,789,210,193,620,774,888,179], function() { return __webpack_exec__(9937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);